import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.243 9.211c0-.368.298-.666.666-.666H14.4c.368 0 .667.298.667.666v3.735a.667.667 0 1 1-1.334 0V9.878H10.91a.667.667 0 0 1-.667-.667M1.6 2.32c.368 0 .667.3.667.668v3.067H5.09a.667.667 0 1 1 0 1.334H1.6a.667.667 0 0 1-.667-.667V2.988c0-.369.299-.667.667-.667",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.351 1.95a5.6 5.6 0 0 1 2.965-.093 5.8 5.8 0 0 1 2.625 1.441 6.3 6.3 0 0 1 1.631 2.592.667.667 0 0 1-1.265.419 5 5 0 0 0-1.284-2.045 4.46 4.46 0 0 0-2.021-1.111 4.24 4.24 0 0 0-2.257.071 4.5 4.5 0 0 0-1.973 1.254l-2.7 2.714a.667.667 0 0 1-.945-.94L3.82 3.545A5.84 5.84 0 0 1 6.35 1.95m8.52 6.789c.26.26.261.682.002.943l-2.693 2.706a5.84 5.84 0 0 1-2.531 1.595 5.6 5.6 0 0 1-2.965.093 5.8 5.8 0 0 1-2.625-1.441 6.3 6.3 0 0 1-1.632-2.592.667.667 0 1 1 1.266-.419 5 5 0 0 0 1.284 2.045c.58.55 1.275.931 2.021 1.112.746.18 1.521.156 2.257-.072a4.5 4.5 0 0 0 1.973-1.254l2.7-2.714a.667.667 0 0 1 .942-.002",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })